import { mix } from "@chorda/core";
export const Tag = (props) => {
    return mix({
        css: 'tag',
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        text: props.text
    });
};
export const Tags = (props) => {
    return mix({
        css: 'tags',
        defaultItem: Tag
    }, props === null || props === void 0 ? void 0 : props.as, props && {
        items: props.tags,
        defaultItem: props.defaultTag,
    });
};
